// extracted by mini-css-extract-plugin
module.exports = {"theme_switcher":"SubheadersThemeSwitch_theme_switcher__4h-Dg","dark":"SubheadersThemeSwitch_dark__3zCrM","light":"SubheadersThemeSwitch_light__SmmHP"};